// Shopify のプラン別料率・月額。楽天の rakutenFeeRates.js に相当する。
// 出典: https://www.shopify.com/jp/pricing （2026-08 時点の日本向け価格）
//
// 楽天と違い Shopify は「売上に応じた累進」がなく、プランで料率が一意に決まるため
// テーブル引きだけで済む。月額は年払い/月払いで変わるので shop 側に billingCycle を持たせる。

const planOptions = [
  { value: 'basic', label: 'ベーシック' },
  { value: 'grow', label: 'スタンダード（Grow）' },
  { value: 'advanced', label: 'プレミアム（Advanced）' },
  { value: 'plus', label: 'Plus' },
];

const billingCycleOptions = [
  { value: 'monthly', label: '月払い' },
  { value: 'yearly', label: '年払い' },
];

// プラン月額（円・税別）。yearly は「年払い時の月あたり換算額」
const planMonthlyFees = {
  basic: { monthly: 4850, yearly: 3650 },
  grow: { monthly: 13500, yearly: 10100 },
  advanced: { monthly: 58500, yearly: 44000 },
  // Plus は個別見積り（368,000円/月〜）。既定値は入れず 0 とし、手入力の経費で調整してもらう
  plus: { monthly: 0, yearly: 0 },
};

// Shopify ペイメントの決済手数料率（オンラインカード）
//   domestic: 国内カード / overseas: 海外カード・Amex
// Plus は個別契約のため Advanced 相当を暫定値として置く
const paymentRates = {
  basic: { domestic: 0.0355, overseas: 0.039 },
  grow: { domestic: 0.034, overseas: 0.0385 },
  advanced: { domestic: 0.0325, overseas: 0.038 },
  plus: { domestic: 0.0325, overseas: 0.038 },
};

// Shopify ペイメント以外の決済を使った場合に別途かかる取引手数料率
const externalTransactionRates = {
  basic: 0.02,
  grow: 0.01,
  advanced: 0.006,
  plus: 0.002,
};

// プランの月額を返す（円）。未設定・Plus は 0。
// フォーム未選択の select は undefined ではなく null が入るため、
// デフォルト引数では拾えない。明示的に正規化する。
const computeMonthlyFee = (plan, billingCycle) =>
  planMonthlyFees[plan]?.[billingCycle ?? 'monthly'] ?? 0;

// 決済手数料率を返す。海外カード比率が分からないので既定は国内レート
const computePaymentRate = (plan, { isOverseas = false } = {}) =>
  paymentRates[plan ?? 'basic']?.[isOverseas ? 'overseas' : 'domestic'] ?? 0;

// Shopify ペイメント未使用時の追加取引手数料率
const computeExternalTransactionRate = (plan) => externalTransactionRates[plan] ?? 0;

exports.planOptions = planOptions;
exports.billingCycleOptions = billingCycleOptions;
exports.planMonthlyFees = planMonthlyFees;
exports.paymentRates = paymentRates;
exports.externalTransactionRates = externalTransactionRates;
exports.computeMonthlyFee = computeMonthlyFee;
exports.computePaymentRate = computePaymentRate;
exports.computeExternalTransactionRate = computeExternalTransactionRate;
